import { CommonModule as NgCommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from "@angular/core";
import { FooterModule } from "@obg/core.footer";
import { MatCoreModule } from "@obg/mat.ui.core";
import { CoreModule } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { RouterModule } from "@obg/ngx.router";
import { CoreUiModule, DynamicLayoutHandler } from "@obg/ngx.ui.core";
import { GlobalUiScrollbarModule } from "@obg/ngx.ui.global.scrollbar";
import { NgScrollbarModule } from "ngx-scrollbar";

import { HeaderModule } from "../../header/header.module";

import { CoreLayoutContainer } from "./core-layout.container";

const DIRECTIVES = [CoreLayoutContainer];

@NgModule({
	imports: [
		NgCommonModule,
		MatCoreModule,
		CoreModule,
		CoreContentModule,
		RouterModule,
		CoreUiModule,
		GlobalUiScrollbarModule,
		NgScrollbarModule,
		HeaderModule,
		FooterModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CoreLayoutModule {
	constructor(dynamicLayoutHandler: DynamicLayoutHandler, injector: Injector) {
		dynamicLayoutHandler.registerComponentInjector(CoreLayoutContainer, injector);
	}
}
